import { EmbeddedMessage, IN_APP, PUSH } from 'constants/messageMediums';
import styled from 'styled-components';
import { Spinner } from 'ui/spinner';
import { body2 } from 'ui/theme';
import { useCreateCampaignContext } from '../campaignFolders/contexts/CreateCampaignContext';
import { useSelectiveTargeting } from '../hooks';
import { ControlledSelectiveTargeting, SelectiveTargetingEmptyState } from './SelectiveTargeting';

const StyledSelectiveTargeting = styled.div`
  ${body2}
`;

const SelectiveTargetingEmptyStateWrapper = styled.div`
  padding-bottom: 0.1px; /* hack to overcome margin collapsing weirdness. we should revisit the whole margin logic in this form later. */
`;

export const Destination = () => {
  const { messageMedium } = useCreateCampaignContext();

  const {
    messageableAppsForPush,
    messageableAppsForInApp,
    areMobileAppsStillBeingFetched,
    isSelectiveTargetingEnabled,
    setIsSelectiveTargetingEnabled,
  } = useSelectiveTargeting();

  const getMessageableAppsForCurrentMedium = () => {
    if (messageMedium === PUSH || messageMedium === EmbeddedMessage) return messageableAppsForPush;
    else if (messageMedium === IN_APP) return messageableAppsForInApp;
    else return [];
  };

  const hasMessageableApps = getMessageableAppsForCurrentMedium().length > 0;

  return (
    <StyledSelectiveTargeting>
      {areMobileAppsStillBeingFetched ? (
        <Spinner />
      ) : (
        <>
          {hasMessageableApps ? (
            <ControlledSelectiveTargeting
              data-test="controlled-selective-targeting"
              messageMedium={messageMedium}
              mobileApps={getMessageableAppsForCurrentMedium()}
              isSelectiveTargetingEnabled={isSelectiveTargetingEnabled}
              setIsSelectiveTargetingEnabled={setIsSelectiveTargetingEnabled}
              name="mobileAppIds"
            />
          ) : (
            <SelectiveTargetingEmptyStateWrapper>
              <SelectiveTargetingEmptyState messageMedium={messageMedium} />
            </SelectiveTargetingEmptyStateWrapper>
          )}
        </>
      )}
    </StyledSelectiveTargeting>
  );
};
